const {NotFoundError} = require('../errors');
const {scalePagesRegex} = require('../routes');

function getComponentName(Component) {
    return Component.displayName || Component.name;
}

async function loadGetInitial(fnName, Component, ...args) {
    if (typeof Component[fnName] !== 'function') {
        return {};
    }

    const data = await Component[fnName](...args);

    if (typeof data !== 'object') {
        const compName = getComponentName(Component) || 'Component';
        const message = `"${compName}.${fnName}()" should resolve to an object. But found "${typeof data}" instead.`;
        throw new TypeError(message);
    }

    return data;
}

const loadGetAppData = loadGetInitial.bind(this, 'getAppData');
const loadGetInitialData = loadGetInitial.bind(this, 'getInitialData');
const loadGetInitialProps = loadGetInitial.bind(this, 'getInitialProps');

function getSlashRedirectPath(path) {
    return path.endsWith('/') ? path.slice(0, -1) : `${path}/`;
}

function serializeObject(obj, join = '&') {
    return Object.keys(obj)
        .map((key) => `${key}=${obj[key]}`)
        .join(join);
}

function getPageFromPath(pathname = '') {
    return pathname === '/' ? 'root' : pathname.substring(1);
}

function getRealPathname(pathname = '/') {
    const realPath = pathname.replace(scalePagesRegex, '');
    return realPath.startsWith('/') ? realPath : `/${realPath}`;
}

function getInternalPathname(pathname = '/', referrer = '/') {
    if (scalePagesRegex.test(referrer)) {
        return scalePagesRegex.test(pathname)
            ? pathname
            : pathname.replace(/^(\/|\/([?#].*)|(\/.+))$/, '/scale-2021$2$3');
    }

    return pathname;
}

function notFoundIfFalse(condition) {
    if (!condition) {
        throw new NotFoundError();
    }

    return condition;
}

function toArray(object) {
    return Array.isArray(object) ? object : [object];
}

function allowOnlyLocale({lang, region}, {langs, regions}) {
    const allowedLangs = langs && toArray(langs);
    const allowedRegions = regions && toArray(regions);

    const langAllowed = !allowedLangs || allowedLangs.includes(lang);
    const regionAllowed = !allowedRegions || allowedRegions.includes(region);

    return notFoundIfFalse(langAllowed && regionAllowed);
}

function allowRuOnly(locale) {
    return allowOnlyLocale(locale, {langs: 'ru'});
}

function allowStaffOnly(user) {
    return notFoundIfFalse(user.hasStaffLogin);
}

module.exports = {
    loadGetAppData,
    loadGetInitialData,
    loadGetInitialProps,
    getComponentName,
    getSlashRedirectPath,
    serializeObject,
    getPageFromPath,
    getRealPathname,
    getInternalPathname,
    allowRuOnly,
    allowOnlyLocale,
    allowStaffOnly,
};
